import React from 'react'
import styled, { css } from 'styled-components'
// import { media } from '../../styles/vars'
import './comment.scss'

const Container = styled.div`
max-height:0;
overflow:hidden;
visbility:hidden;
opacity: .2;
transition: max-height .5s, opacity .5s, visibility .5s;
${props => props.active ? `
max-height:500px;
opacity:1;
visibility:visible;
` : ''}
`

const commonInputCss = css`
flex-grow:1;
border: none;
padding: 10px;
margin: 0;
color: #3c444d;
font-size:18px;
@media screen and (min-width: 750px) {
    &:not(:last-child){
        margin:0 0 0 20px;
    }
    font-size:20px;

    }
`
const Input = styled.input`
${commonInputCss}
:not(:last-child) {
    margin:0 0 15px 0;
}
@media screen and (min-width: 750px) {
    &:not(:last-child){
        margin:0 0 0 20px;
    }

    }
`
const Textarea = styled.textarea`
${commonInputCss}
resize:none;
height:100px;
`
const InlineWrp = styled.div`
white-space:nowrap;
margin-bottom:15px;
display:flex;
justify-content:space-between;
flex-direction:column;
@media screen and (min-width: 750px) {
    flex-direction:row;
    }
`
const Note = styled.p`
font-size:14px;
margin:5px 0;
white-space:normal;
color:#3c444d;
padding-left:10px;

a, a:visited, a:hover{
    color:#6a289b;
    text-decoration:underline;
}
@media screen and (min-width: 750px) {
    font-size:18px;

    }
`
const SubmitButton = styled.button`
color: #fff;
background-color: #6a289b;
padding:5px 20px 1px;
font-size:18px;
opacity: .4;
filter:grayscale(100%);
transition: opacity .4s, filter .4s;

${props => props.valid ?
        `
    opacity:1;
    filter:unset;
    cursor:pointer;
    ` :
        `
        opacity: .4;
        filter:grayscale(100%);
     `
    }

    @media screen and (min-width: 750px) {
        font-size: 22px;
        padding: 12px 40px 9px;
    }
`
const CommentForm = (props) => {
    return (
        <Container active={props.isActive}>
            <form onSubmit={props.handleSubmit}>
                <div>
                    <InlineWrp>
                        <Input
                            type="text"
                            maxLength="70"
                            placeholder="שם"
                            value={props.inputName}
                            name="inputName"
                            onChange={props.handleChange}
                        />
                        <Input
                            type="text"
                            maxLength="70"
                            placeholder="כותרת"
                            name="inputTitle"
                            value={props.inputTitle}
                            onChange={props.handleChange}
                        />
                    </InlineWrp>
                </div>
                <InlineWrp>
                    <Textarea
                        maxLength="600"
                        placeholder="תוכן"
                        name="inputContent"
                        value={props.inputContent}
                        onChange={props.handleChange}
                    ></Textarea>
                </InlineWrp>
                <InlineWrp>
                    <Note>
                        אין לשלוח תגובות הכוללות מידע המפר את&nbsp;
                    <a
                            href="//www.ynet.co.il/home/0,7340,L-827,00.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            תנאי השימוש של ynet
                    </a>&nbsp;
                    לרבות דברי הסתה, דיבה וסגנון החורג מהטעם הטוב.
               </Note>
                    <SubmitButton valid={props.isValid}>שלח תגובה</SubmitButton>
                </InlineWrp>
            </form>
        </Container>
    )
}

export default CommentForm;


// WEBPACK FOOTER //
// ./src/Components/comments/CommentForm.jsx